import { render, staticRenderFns } from "./AutoSignExcludedBranches.vue?vue&type=template&id=476891e6&scoped=true"
import script from "./AutoSignExcludedBranches.vue?vue&type=script&lang=js"
export * from "./AutoSignExcludedBranches.vue?vue&type=script&lang=js"
import style0 from "./AutoSignExcludedBranches.vue?vue&type=style&index=0&id=476891e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476891e6",
  null
  
)

export default component.exports